import {ReactNode} from "react";

// Static notice, so no role="alert": screen readers read it in place rather than announcing it.
export function ClosedBetaNotice({className = '', children}: { className?: string, children: ReactNode }) {
    return (
        <div className={`alert alert-info d-flex gap-2 ${className}`}>
            <i className="bi bi-info-circle-fill" aria-hidden="true"/>
            <div>{children}</div>
        </div>
    );
}
